import axios from "axios";

const disqavaApi = axios.create({
  baseURL: "https://disqavad.com/wp-json/wp/v2/",
  // baseURL: "https://homeoffice.fm/wp-json/wp/v2/",
});

export default disqavaApi;
